/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { ThemeProvider } from './src/context';

export const wrapRootElement = ({ element }) => {
    return <ThemeProvider>{element}</ThemeProvider>;
};

export const onServiceWorkerUpdateReady = () => {
    if (typeof window !== 'undefined') {
        window.location.reload();
    }
};

// Using Gatsby's native scroll handling
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    // Return false to prevent default scroll behavior
    return false;
};

// Handle scroll restoration
export const onRouteUpdate = ({ location }) => {
    if (process.env.NODE_ENV === 'production') {
        if (typeof window === 'undefined') {
            return;
        }

        try {
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant'
                });
            }, 0);
        } catch (e) {
            // Fallback for older browsers
            window.scrollTo(0, 0);
        }
    }
};